import { isTyomarkkinatoriCompanyId } from './is-tyomarkkinatori-company-id';

/**
 * Keeps relative order within each group; places all Työmarkkinatori facet rows last.
 */
export function partitionCompanyFacetsTyomarkkinatoriLast<T extends { value: string; label?: string }>(
  items: readonly T[]
): T[] {
  const tyomarkkinatori: T[] = [];
  const rest: T[] = [];
  for (const item of items) {
    if (isTyomarkkinatoriCompanyId(item.value) || isTyomarkkinatoriCompanyId(item.label ?? '')) {
      tyomarkkinatori.push(item);
    } else {
      rest.push(item);
    }
  }
  return [...rest, ...tyomarkkinatori];
}
